import * as idb from "idb";
import { Attempt, Product } from "@sabyr-dev/mist_elibrary/datasource";

import { getAttemptId, getCookie, getProductId } from "./academy";

export class AcademyLocalDatabase {
	static readonly global: string = 'globalState';
	static readonly attempt: string = 'attemptState';
	private static locks: Record<string, Promise<boolean>> = {};

	async getDb(): Promise<idb.IDBPDatabase> {
		return await idb.openDB('elibraryMist', 1, {
			upgrade(db: idb.IDBPDatabase) {
				db.createObjectStore(AcademyLocalDatabase.global);
				db.createObjectStore(AcademyLocalDatabase.attempt);
			}
		});
	}

	async write(
		store: string,
		id: string,
		callback: (transaction: idb.IDBPTransaction<unknown, [string], 'readwrite'>) => Promise<boolean>
	): Promise<boolean> {
		const db = await this.getDb();
		if (!(store in AcademyLocalDatabase.locks)) {
			AcademyLocalDatabase.locks[store] = Promise.resolve(true);
		}
		return AcademyLocalDatabase.locks[store] = AcademyLocalDatabase.locks[store].then(async () => {
			const transaction = db.transaction(store, 'readwrite');
			await callback(transaction);
			await transaction.done;
			return true;
		});
	}

	getGlobalKey(): string {
		return getCookie();
	}

	getAttemptKey(product?: Product, attempt?: Attempt, cookie?: string): string {
		return `${product ?? getProductId()}.${attempt ?? getAttemptId()}.${cookie ?? getCookie()}`;
	}
}
